import type { ThemeOptions } from '@mui/material/styles'

/**
 * Brand overlay for Vantage. Composed onto `coreTheme` via `composeTheme` to
 * produce `vantageTheme`. Treat this as the canonical pattern for any new
 * partner theme: declare the brand-owned palette keys here; let MUI's
 * `createTheme` and `composeTheme` derive `light`/`dark`/`contrastText` from
 * `main` where they are not explicitly supplied.
 */
export const vantageThemeOverlay: ThemeOptions = {
  palette: {
    primary: {
      main: '#59C69C',
      contrastText: '#FAFFF9',
    },
    secondary: {
      main: '#F35931',
      contrastText: '#FAFFF9',
    },
    error: {
      main: '#df3940',
    },
    info: {
      main: '#3db1c8',
      dark: '#236d7c',
    },
    success: {
      light: '#78be43',
      main: '#50bc7f',
      dark: '#006830',
    },
    warning: {
      main: '#e3aa00',
      dark: '#f96302',
    },
    selected: {
      main: '#97B9FF',
    },
  },
}
